module.exports = "../images/stage-trout-forest-music-festival@2x.jpg?v=54594dc";